var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 7.69999C19.2 10.352 15.9768 12.5 12 12.5C8.02325 12.5 4.80005 10.352 4.80005 7.69999C4.80005 5.04799 8.02325 2.89999 12 2.89999C15.9768 2.89999 19.2 5.04799 19.2 7.69999ZM18.9 11.1236C17.382 12.68 14.856 13.7 12 13.7C9.14405 13.7 6.61805 12.68 5.10005 11.1236C4.90565 11.5592 4.80005 12.02 4.80005 12.5C4.80005 15.152 8.02325 17.3 12 17.3C15.9768 17.3 19.2 15.152 19.2 12.5C19.1984 12.0252 19.0962 11.556 18.9 11.1236ZM18.9 15.9236C17.382 17.48 14.856 18.5 12 18.5C9.14405 18.5 6.61805 17.48 5.10005 15.9236C4.90565 16.3592 4.80005 16.82 4.80005 17.3C4.80005 19.952 8.02325 22.1 12 22.1C15.9768 22.1 19.2 19.952 19.2 17.3C19.1984 16.8252 19.0962 16.356 18.9 15.9236Z",
    fill: "#454951"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.6edf577b956f45622e73cb530e48c572.svg";
export { ForwardRef as ReactComponent };